import type { Element } from '@xmldom/xmldom'
import L6ToL5TagProcessor from "./TagProcessor"
import { DefaultProps } from "./DefaultProps"
import { CidPath, Concept } from "../../concept/Concept"

class ConceptTagProcessor extends L6ToL5TagProcessor {
	interpolateTitle(node: Element, defaultProps: DefaultProps) {
		if(!defaultProps?.cid) {
			return
		}
		const wrappingConcept = this.rootProc.concepts[defaultProps.cid]
		let title = node.getAttribute('title')
		if(title !== null && title.includes('{{concept.title}}') && wrappingConcept?.title) {
			node.setAttribute('title', title.replaceAll('{{concept.title}}', wrappingConcept.title))
		}
	}

	process(node: Element, xpath: string, baseCidPath: CidPath, defaultProps: DefaultProps): [boolean, Concept|null] {
		if(!this.rootProc.translateDirItemId(node, 'dirItemId', 'cid', true)) {
			return [false, null]
		}
		this.interpolateTitle(node, defaultProps)
		const concept = this.rootProc.getConcept(node, xpath, baseCidPath)
		return [concept !== null, concept]
	}
}

export default ConceptTagProcessor
